export const localFeatureIds = [
  //
  'export video',
  'ss onboarding',
  'smartlook-canvas',
  'viz-options',
  'magic-paint',
  'rich-color-filter',
  'mobile-viz',
  'fp-add-room',
  'professional-trial-14-days',
  'onboarding-pro-schedule',
  'sourcing-assistant',
  'design-assistant',
  'signup-check-email-flow',
  'signup-google-button',
  'template-assistant-no-chat',
  'price-alert',
  'global-cart',
  'viz-magic-render',
  'viz-magic-render-moodboard',
  'viz-magic-render-elevation',
] as const

export const externalFeatureIds = [
  //
  'smartlook-canvas',
  'magic-paint',
  'rich-color-filter',
  'mobile-viz',
  'professional-trial-14-days',
  'onboarding-pro-schedule',
  'sourcing-assistant',
  'design-assistant',
  'signup-check-email-flow',
  'signup-google-button',
  'template-assistant-no-chat',
  'price-alert',
  'viz-options',
  'global-cart',
  'viz-magic-render',
  'viz-magic-render-moodboard',
  'viz-magic-render-elevation',
] as const

export type LocalFeatureId = (typeof localFeatureIds)[number]
export type ExternalFeatureId = (typeof externalFeatureIds)[number]
export type FeatureId = LocalFeatureId | ExternalFeatureId

export function isLocalFeature(
  featureId: FeatureId,
): featureId is LocalFeatureId {
  return localFeatureIds.includes(featureId as LocalFeatureId)
}

export function isExternalFeature(
  featureId: FeatureId,
): featureId is ExternalFeatureId {
  return externalFeatureIds.includes(featureId as ExternalFeatureId)
}
